import React, { useState, useEffect } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { useHistory, useParams } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

import {
  subirImagenesBatch,
  getUserByEmail,
  loadAccountList,
  getUsuerById,
  actualizarRegistro,
} from "../utils/Actions";
import _, { isEmpty } from "lodash";
import Avatar from "@material-ui/core/Avatar";
import { Loading } from "../atoms";
import { generatePasswordRand, sendEmail, validaremail } from "../utils/Utils";

const inintialState = {
  id: "",
  name: "",
  lastname: "",
  userweb: "",
  email: "",
  accountAsigned: "",
  accountAsignedName: "",
  isSupervisor: false,
  rol: "",
  photo: "",
  createdby: "",
  status: true,
  adminpassword: "",
  employeenumber: "",
  reason: "",
};

const roles = [
  { code: 1, title: "Seguridad" },
  { code: 2, title: "Jefe de Operaciones" },
  { code: 3, title: "Administrador" },
  { code: 4, title: "Cliente" },
];

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  icon: {
    alignSelf: "center",
  },
  avatar: {
    width: 100,
    height: 100,
    marginBottom: 20,
  },
}));

export default function EditUser(props) {
  const [state, setstate] = useState(inintialState);
  const [visible, setVisible] = useState(false);
  const [accountlist, setaccountlist] = useState([]);
  let { id } = useParams();
  const usuarioid = id.slice(4);
  let history = useHistory();
  const [values, setValues] = useState({
    showPassword: false,
  });

  console.log("ACCOUNT");
  const account = JSON.parse(localStorage.getItem("Account"));
  console.log(account[0]);

  useEffect(() => {
    (async () => {
      setVisible(true);
      console.log("LOAD ACCOUNT LIST");
      setaccountlist((await loadAccountList()).data);

      const { statusresponse, data } = await getUsuerById(usuarioid);
      console.log("la data es esta");
      console.log(data);
      console.log(data.isSupervisor);
      setstate({ ...state, ...data, isSupervisor: data.isSupervisor });
      console.log(data);
      setVisible(false);
    })();
  }, []);

  const classes = useStyles();

  const defaultProps = {
    options: roles,
    getOptionLabel: (option) => option.title,
  };

  const defaultProps2 = {
    options: accountlist,
    getOptionLabel: (option) => option.name,
  };

  const fileSelectedHandler = async (event) => {
    setVisible(true);
    const resultado = await subirImagenesBatch(event.target.files, "avatarWeb");
    console.log("IMAGEN" + resultado[0]);
    setstate({ ...state, photo: resultado[0] });
    setVisible(false);
  };

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const _saveuser = async () => {
    //1. Subir imagen
    const {
      name,
      lastname,
      accountAsigned,
      rol,
      isSupervisor,
      email,
      photo,
      adminpassword,
      status,
      reason,
    } = state;

    let url = "";
    let numeroempleado = "";

    if (isEmpty(name) || isEmpty(lastname)) {
      alert("Debe ingresar el nombre y el apellido del usuario");
    } else if (!accountAsigned) {
      alert("Debe seleccionar una cuenta de cliente");
    } else if (!rol) {
      alert("Debe seleccionar un rol");
    } else if (isEmpty(photo)) {
      alert("Debe seleccionar una fotografía");
    } else if (!isEmpty(email) && !validaremail(email)) {
      alert("Debe ingresar un correo válido");
    } else {
      setVisible(true);

      //2. Generar claves

      const usuario = {
        ...state,
        photo: photo,
        updatedBy: `${account[0].name} ${account[0].lastname}`,
        adminpassword: rol === 3 ? state.adminpassword : 0,
        status: status,
        isSupervisor,
        reason: status ? "" : reason,
      };

      //        userweb: `${name}.${lastname}`.toLowerCase(),

      const existsuser = await getUserByEmail(email);

      //if (!existsuser.statusresponse === true) {
      const registro = await actualizarRegistro("Usuarios", usuarioid, usuario);

      if (registro.statusresponse === true) {
        let userfinal = `${name}.${lastname}`;

        await sendEmail(
          `<p>Se ha Actualizado el Usuario ${encodeURIComponent(
            userfinal.toLowerCase()
          )}</p> <br/> `,
          `Usuario ${userfinal.toLowerCase()} Actualizado en Sayeret Security`,
          state.email
        );
        //console.log(state.photo);
        setVisible(false);
        setstate({
          inintialState,
        });
        alert("Se ha actualizado el usuario exitosamente");
        history.push("/users");
      } else {
        setVisible(false);
        alert("Ha ocurrido un error - CODIGO" + registro.error);
      }
      /* } else {
        setVisible(false);

        alert("Ya existe un usuario creado con el correo " + email);
      } */
    }
  };

  const getRolDescription = (rol) => {
    if (Number(rol) === 1) {
      return "Seguridad";
    } else if (Number(rol) === 2) {
      return "Jefe de Operaciones";
    } else if (Number(rol) === 3) {
      return "Administrador";
    } else {
      return "Cliente";
    }
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  return (
    <FormControl
      style={{
        backgroundColor: "#fff",
        borderRadius: 5,
        padding: 20,
        paddingBottom: 30,
      }}
    >
      <Typography gutterBottom variant="h5">
        <IconButton>
          <ChevronLeftIcon onClick={() => history.goBack()} />
        </IconButton>
        Editar Usuario {state.employeenumber}
      </Typography>

      <Grid
        item
        xs={12}
        direction="column"
        justify="center"
        alignItems="center"
        container
        spacing={0}
        style={{ marginBottom: 20 }}
      >
        {isEmpty(state.photo) ? (
          <AccountCircleIcon fontSize="large" style={{ fontSize: 50 }} />
        ) : (
          <Avatar alt="Photo" src={state.photo} className={classes.avatar} />
        )}
        <input
          type="file"
          onChange={fileSelectedHandler}
          accept="image/png, image/jpeg"
        />
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={6} sm={6}>
          <TextField
            id="outlined-basic"
            label="Nombre"
            variant="outlined"
            fullWidth
            name="name"
            onChange={onChange}
            value={state.name}
            onSubmit={() => {
              console.log("salio");
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <TextField
            id="outlined-basic"
            label="Apellido"
            variant="outlined"
            fullWidth
            name="lastname"
            onChange={onChange}
            value={state.lastname}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Usuario"
            variant="outlined"
            fullWidth
            name="userweb"
            onChange={onChange}
            disabled
            value={`${state.name}.${state.lastname}`.toLowerCase()}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Correo"
            variant="outlined"
            fullWidth
            type="email"
            name="email"
            onChange={onChange}
            value={state.email}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                onChange={(e) => {
                  setstate({ ...state, isSupervisor: e.target.checked });
                }}
                value={Boolean(state.isSupervisor)}
              />
            }
            label="Supervisor de Cuenta"
            labelPlacement="start"
            checked={Boolean(state.isSupervisor)}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            {...defaultProps}
            id="open-on-focus"
            openOnFocus
            renderInput={(params) => (
              <TextField {...params} label="Asignar Rol" margin="normal" />
            )}
            onChange={(event, newValue) => {
              console.log(newValue);
              setstate({ ...state, rol: _.get(newValue, "code", "1") });
            }}
            value={{ code: state.rol, title: getRolDescription(state.rol) }}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            {...defaultProps2}
            id="open-on-focus"
            openOnFocus
            renderInput={(params) => (
              <TextField {...params} label="Asignar Cuenta" margin="normal" />
            )}
            onChange={(event, newValue) => {
              console.log(newValue);
              if (newValue) {
                setstate({
                  ...state,
                  accountAsigned: newValue.id,
                  accountAsignedName: newValue.name,
                });
              }
            }}
            value={{ name: state.accountAsignedName }}
          />
        </Grid>

        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                onChange={(e) => {
                  setstate({ ...state, status: e.target.checked });
                }}
                value={Boolean(state.status)}
              />
            }
            label="Estatus Empleado"
            labelPlacement="start"
            checked={Boolean(state.status)}
          />
        </Grid>
        {state.status === false && (
          <Grid item xs={4}>
            <TextField
              id="outlined-basic"
              label="Razón de Desactivación"
              variant="outlined"
              fullWidth
              type="text"
              name="reason"
              onChange={onChange}
              value={state.reason}
              multiline
              rows={2}
            />
          </Grid>
        )}
        {state.rol == "3" && (
          <Grid item xs={4}>
            <FormControl variant="outlined">
              <InputLabel htmlFor="standard-adornment-password">
                Admin Pass
              </InputLabel>
              <OutlinedInput
                id="standard-adornment-password"
                type={values.showPassword ? "number" : "password"}
                value={state.adminpassword}
                name="adminpassword"
                onChange={onChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                labelWidth={70}
              />
            </FormControl>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          direction="row"
          justify="center"
          alignItems="center"
          container
        >
          <Button
            size="large"
            variant="contained"
            color="secondary"
            startIcon={<SaveIcon />}
            onClick={_saveuser}
          >
            ACTUALIZAR
          </Button>
        </Grid>
      </Grid>
      <Loading visible={visible} setVisible={setVisible} />
    </FormControl>
  );
}
